const formData = {
  formId: "evaluationForm",
  formField: {
    firstName: {
      name: "firstName",
      label: "First Name",
    },
    middleName: {
      name: "middleName",
      label: "Middle Name",
    },
    lastName: {
      name: "lastName",
      label: "Last Name",
    },
    mmcId: {
      name: "mmcId",
      label: "MMC ID",
    },
    rating: {
      name: "rating",
      label: "Rating",
    },
    vessel: {
      name: "vessel",
      label: "Vessel",
      requiredErrorMessage: "Vessel is required.",
    },
    fromDate: {
      name: "fromDate",
      label: "From",
    },
    toDate: {
      name: "toDate",
      label: "To",
    },
    nearMissSubmissions: {
      name: "nearMissSubmissions",
      label: "Near Miss Submissions",
    },
    lostTimeInjuries: {
      name: "lostTimeInjuries",
      label: "Lost Time Injuries",
    },
    restrictedWorkInjuries: {
      name: "restrictedWorkInjuries",
      label: "Restricted Work Injuries",
    },
    medicalTreatmentInjuries: {
      name: "medicalTreatmentInjuries",
      label: "Medical Treatment Injuries",
    },
    scores: {
      name: "scores",
      label: "Performance Evaluation",
    },
    assessor1: {
      name: "assessor1",
      label: "Assessor 1 - Full Name",
    },
    assessor1Comment: {
      name: "assessor1Comment",
      label: "Comments",
    },
    assessor1CommentHelper: {
      name: "assessor1CommentHelper",
      label: "Comments",
    },
    assessor2: {
      name: "assessor2",
      label: "Assessor 2 - Full Name",
    },
    assessor2Comment: {
      name: "assessor2Comment",
      label: "Comments",
    },
    assessor2CommentHelper: {
      name: "assessor2CommentHelper",
      label: "Comments",
    },
    finalReviewer: {
      name: "finalReviewer",
      label: "Final Reviewer - Full Name",
    },
    finalReviewerComment: {
      name: "finalReviewerComment",
      label: "Comments",
    },
    finalReviewerCommentHelper: {
      name: "finalReviewerCommentHelper",
      label: "Comments",
    },
    evaluatee: {
      name: "evaluatee",
      label: "Senior Officer - Full Name",
    },
    evaluateeComment: {
      name: "evaluateeComment",
      label: "Comments",
    },
    evaluateeCommentHelper: {
      name: "evaluateeCommentHelper",
      label: "Comments",
    },
    status: {
      name: "status",
      label: "Status",
    },
    readyForPromotion: {
      name: "readyForPromotion",
      label: "Ready for Promotion?",
    },
    hasPreviousWarnings: {
      name: "hasPreviousWarnings",
      label: "Previous warning(s) issued?",
    },
    reviewedWithMariner: {
      name: "reviewedWithMariner",
      label: "Reviewed With Mariner?",
    },
  },
};

export default formData;
